import { RoleId } from 'core/types/role';
import { TranslationStrings } from './translation-types';

export function translateRole(id: RoleId): TranslationStrings {
  switch (id) {
    case 'none':
      return 'roles.none';

    case 'organization:administrator':
      return 'roles.organization:administrator';

    case 'organization:it-manager':
      return 'roles.organization:it-manager';

    case 'organization:user':
      return 'roles.organization:user';

    case 'group:manager':
      return 'roles.group:manager';

    case 'group:user':
      return 'roles.group:user';

    case 'share:manager':
      return 'roles.share:manager';

    case 'share:user':
      return 'roles.share:user';

    case 'share:reader':
      return 'roles.share:reader';

    case 'share:videocaller':
      return 'roles.share:videocaller';

    case 'clock:user':
      return 'roles.clock:user';

    case 'clock:reader':
      return 'roles.clock:reader';

    case 'calendar:manager':
      return 'roles.calendar:manager';

    case 'calendar:user':
      return 'roles.calendar:user';

    case 'calendar:reader':
      return 'roles.calendar:reader';

    case 'videos:user':
      return 'roles.videos:user';

    case 'contentpackages:manager':
      return 'roles.contentpackages:manager';

    case 'contentpackages:user':
      return 'roles.contentpackages:user';

    default:
      throw new TypeError(`Uknown role id ${id}`);
  }
}

export default undefined;
